export default "__VITE_ASSET__w$TSH3WM__"